import { LinearProgress } from '@mui/material';
import ProgressBar from '../progress-bar/ProgressBar';

export function Loading() {
  return (
    <>
      <ProgressBar />
      <LinearProgress color="inherit" sx={{ width: 1, maxWidth: '100%' }} />
    </>
  );
}
